module.exports = __webpack_public_path__ + "img/portfolio_10.6cdac1f1.jpg";